import * as React from 'react'

import { classList } from 'react-classlist-helper'

interface FieldProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: 'vertical' | 'horizontal'
  disabled?: boolean
}

export function Field({
  orientation = 'vertical',
  disabled,
  className,
  children,
  ...props
}: FieldProps) {
  return (
    <div
      role="group"
      data-slot="field"
      data-orientation={orientation}
      data-disabled={disabled || undefined}
      className={classList({
        'tw:flex tw:w-full tw:gap-2': true,
        'tw:flex-col': orientation === 'vertical',
        'tw:flex-row tw:items-start': orientation === 'horizontal',
        'tw:opacity-50 tw:pointer-events-none': disabled,
        [className]: !!className,
      })}
      {...props}
    >
      {children}
    </div>
  )
}

type FieldContentProps = React.HTMLAttributes<HTMLDivElement>

export function FieldContent({
  className,
  children,
  ...props
}: FieldContentProps) {
  return (
    <div
      data-slot="field-content"
      className={classList({
        'tw:flex tw:flex-1 tw:flex-col tw:gap-0.5': true,
        [className]: !!className,
      })}
      {...props}
    >
      {children}
    </div>
  )
}

type FieldLabelProps = React.LabelHTMLAttributes<HTMLLabelElement>

export function FieldLabel({ className, children, ...props }: FieldLabelProps) {
  return (
    <label
      data-slot="field-label"
      className={classList({
        'tw:flex tw:items-center tw:gap-2 tw:select-none': true,
        [className]: !!className,
      })}
      {...props}
    >
      {children}
    </label>
  )
}
